export default "__VITE_ASSET__c5fe2427__"